import React, { Component } from 'react';
import { reduxForm } from 'redux-form';
import axios from 'axios';
import generateValidator from './Validations/generateValidator';
import {FormattedHTMLMessage} from 'react-intl';
import withAuthControl from '../auth/Auth.js';
import TopScrolleable from './TopScrolleable.js'
import Section from './Section.js'
import CustomSpinner from './CustomSpinner';
import LoadField from './LoadField';
import CustomAlert from '../components/CustomAlert.js';
import WorkDependenceForm from './WorkDependenceForm.js';
import SelfEmploymentForm from './SelfEmploymentForm.js';

class IncomesForm extends Component {

    constructor(props) {
        super(props);
        this.checkEmploymentType = this.checkEmploymentType.bind(this);
        this.state = {
            employment: false,
            type: false
        }
    }

    componentWillMount(){
        this.props.setDefaultValue({salary_type: 1 });
        this.checkEmploymentType();
    }

    checkEmploymentType(){
        const ROOT_URL = process.env.API_URL;

        var config = {
            headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + sessionStorage.getItem('jwtToken')
            }
        };
        /*TODO: REFACTOR this */
        axios.get(ROOT_URL + '/subscribers/employment_type', config)
            .then(res => {
                const data = res.data;
                if(data.type === 'work_dependence'){
                    this.props.setDefaultValue({salary_type: '0' ,check_stubs: [{}] });
                }else{
                    this.props.setDefaultValue({self_employment_incomes: [{}] });
                }
                this.setState({ employment: data.name,
                                    type: data.type});
            }
        );
    }

    render() {

        const { handleSubmit, submitting, error } = this.props;
        return (
            <Section className="intro_form">
                <div className="row">
                    <div className="pd-content-left col-md-5 col-lg-5 text-center">
                        <img alt="Logo" className="center-block intro_logo" src={require(`../assets/${process.env.PAGE}/img/logo-h-blanco.png`)}/>
                        <FormattedHTMLMessage id="app.step_incomes" description="Incomes info"/>
                    </div>
                    <div className="pd-content-right col-sm-12 col-md-7 col-lg-7">
                        <form onSubmit={handleSubmit(this.props.saveIncomes)} className="pvc-form">
                            {this.props.isLoading && <CustomSpinner message='Estamos analizando tu solicitud. Por favor esperá...' /> }
                            {error && <CustomAlert bsStyle="danger" message={error}/>}
                            <LoadField>
                                {(this.state.type && ((this.state.type==='work_dependence' && <WorkDependenceForm deleteReduxFormField={this.props.deleteReduxFormField}/>) || (this.state.type==='self_employment' && <SelfEmploymentForm selfEmploymentType={this.state.employment} deleteReduxFormField={this.props.deleteReduxFormField}/>)))}
                            </LoadField>
                            <div className="row">
                                <div className="col-sm-12 col-md-12 col-lg-12 text-center">
                                    <button type="submit" className="btn btn-warning btn-lg pd-button pd-form" disabled={submitting}>Continuar</button>
                                </div>
                            </div>
                        </form>
                    </div>
                </div>
            </Section>
        );
    }
}

IncomesForm.contextTypes = {
    intl: React.PropTypes.object.isRequired
}

let validate = generateValidator([{name: 'check_stubs', value:
                                        [{name: 0, value:[
                                            {'required':true, 'name':'remuneration_date'},
                                            {'required':true, 'range':{'min':0}, 'name':'full_remuneration'},
                                            {'required':true, 'range':{'min':0}, 'name':'discounts'}]},
                                         {name: 1, value:[
                                            {'required':true, 'name':'remuneration_date'},
                                            {'required':true, 'range':{'min':0}, 'name':'full_remuneration'},
                                            {'required':true, 'range':{'min':0}, 'name':'discounts'}]},
                                        ]},
                                    {name: 'monotributo_category', required:true},
                                    {name: 'monthly_costs', 'range':{'min':0}, required:true},
                                    {name: 'number_of_employees','range':{'min':0}, required:true},
                                    {name: 'leasing_type', required:true},
                                    {name: 'leasing_value', required:true},
                                    {name: 'self_employment_incomes', value:
                                        [{name: 0, value:[
                                            {required:true, name:'date'},
                                            {required:true, 'range':{'min':0}, 'name':'net_income_tax'},
                                            {required:true, 'range':{'min':0}, 'name':'self_employment_payment'},
                                            {required:true, 'range':{'min':0}, 'name':'net_income'},]}
                                        ]}
                                ])

IncomesForm = TopScrolleable(IncomesForm);

IncomesForm = reduxForm({
    form: 'IncomesForm', // a unique name for this form
    validate
})(IncomesForm);

IncomesForm = withAuthControl(IncomesForm);

export default IncomesForm;


/** WEBPACK FOOTER **
 ** ./src/components/IncomesForm.js
 **/